import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PerfilRotinaRestricao} from '../model/perfil/perfil-rotina-restricao.model';

@Injectable({
  providedIn: 'root'
})
export class PerfilRotinaResticaoService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/perfil-rotina-restricao`;

  buscarPerfilRotinaRestricaoPorPerfilERotina(perfilId: number, rotinaId: number): Observable<PerfilRotinaRestricao[]> {
    return this.http.get<PerfilRotinaRestricao[]>(`${this.urlBase}/buscar/perfil/${perfilId}/rotina/${rotinaId}`);
  }

  alterarPermicao(restricao: PerfilRotinaRestricao): Observable<boolean> {
    return this.http.put<boolean>(`${this.urlBase}`, restricao);
  }
}
